import React from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import { useDashboardMode } from '../../context/DashboardModeContext';
import css from './SettingsSubNav.module.css';

const TABS = [
  { label: 'Profile', page: 'ProfileSettingsPage', linkName: 'ProfileSettingsPage' },
  // "Credentials" (short) instead of "Credentials & Documents" to
  // save horizontal space; the in-tab heading is still the long form.
  // Host-only: permits/COI uploads mean nothing to a renter (audit 22).
  { label: 'Credentials', page: 'CredentialsPage', linkName: 'CredentialsPage', providerOnly: true },
  { label: 'Contact', page: 'ContactDetailsPage', linkName: 'ContactDetailsPage' },
  { label: 'Password', page: 'PasswordChangePage', linkName: 'PasswordChangePage' },
  // Saved cards — for everyone who pays (audit 22: renters previously
  // had NO route to payment methods; the only "Payments" tab was the
  // host payout page).
  { label: 'Payments', page: 'PaymentMethodsPage', linkName: 'PaymentMethodsPage' },
  { label: 'Payouts', page: 'StripePayoutPage', linkName: 'StripePayoutPage', providerOnly: true },
  { label: 'Account', page: 'ManageAccountPage', linkName: 'ManageAccountPage' },
];

const SettingsSubNav = ({ currentPage, role }) => {
  // Gate provider-only tabs on actual host status (has listings OR Stripe
  // connected) instead of "is allowed to create listings", which is
  // every authenticated user. canSwitchModes is the same source of truth
  // the topbar Hosting/Renting toggle uses (DashboardModeContext) so the
  // settings nav stays consistent with the toggle's visibility rule.
  // See feedback that pure renters were seeing "Payments" (Stripe
  // payout page) — they shouldn't.
  const { canSwitchModes } = useDashboardMode();
  const visibleTabs = canSwitchModes ? TABS : TABS.filter(t => !t.providerOnly);
  const roleSearch = role ? { search: `?role=${role}` } : undefined;

  return (
    <nav className={css.subNav}>
      {visibleTabs.map(tab => {
        const isActive = currentPage === tab.page;
        return (
          <NamedLink
            key={tab.page}
            name={tab.linkName}
            to={roleSearch}
            className={classNames(css.tab, { [css.tabActive]: isActive })}
          >
            {tab.label}
          </NamedLink>
        );
      })}
    </nav>
  );
};

export default SettingsSubNav;
